import {actionTypes} from '../../../types';

// Action creator for generating OTP request
export const verifyOtpAndCreateAgencyUser = (payload) => ({
    type: actionTypes.VERIFY_OTP_AND_CREATE_AGENCY_USER_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const verifyOtpAndCreateAgencyUserSuccess = (payload) => ({
    type: actionTypes.VERIFY_OTP_AND_CREATE_AGENCY_USER_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const verifyOtpAndCreateAgencyUserFailure = (payload) => ({
    type: actionTypes.VERIFY_OTP_AND_CREATE_AGENCY_USER_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const verifyOtpAndCreateAgencyUserReset = () => ({
    type: actionTypes.VERIFY_OTP_AND_CREATE_AGENCY_USER_RESET,
});

// Action creator for resetting all OTP generation reducer
export const verifyOtpAndCreateAgencyUserResetAll = () => ({
    type: actionTypes.VERIFY_OTP_AND_CREATE_AGENCY_USER_RESET_ALL,
});
